"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AmountSelection = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PaymentContext = _interopRequireDefault(require("../../context/PaymentContext"));
var _AmountSelection2 = require("../../components/AmountSelection");
var _browser = require("../../browser");
var _templateObject;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var OptionsContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  padding-bottom: 10px;\n"])));
var AmountSelection = exports.AmountSelection = function (_PureComponent) {
  function AmountSelection() {
    var _this;
    (0, _classCallCheck2["default"])(this, AmountSelection);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
    return _this = _callSuper(this, AmountSelection, [].concat(args)), (0, _defineProperty2["default"])(_this, "state", {
      selected: null,
      amount: undefined
    }), _this = _callSuper(this, AmountSelection, [].concat(args)), (0, _defineProperty2["default"])(_this, "state", {
      selected: null,
      amount: undefined
    }), _this;
  }
  return (0, _inherits2["default"])(AmountSelection, _PureComponent), (0, _createClass2["default"])(AmountSelection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var paymentOptions = this.props.paymentOptions;
      var selectedOption = paymentOptions.find(function (option) {
        return option.isDefault;
      });
      var optionName = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.name;
      optionName && this.setState({
        selected: optionName,
        amount: selectedOption.isInput ? selectedOption.defaultValue : parseInt(selectedOption.amount, 10)
      });
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(option) {
      this.setState({
        selected: option.name,
        amount: option.isInput ? option.defaultAmount : parseInt(option.amount, 10)
      });
    }
  }, {
    key: "handleInputSelectAmount",
    value: function handleInputSelectAmount(event) {
      event.persist();
      var value = event.target.value;
      this.setState({
        amount: parseInt(value, 10)
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      var amount = this.state.amount;
      event.preventDefault(), this.props.setAmount(amount);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var selected = this.state.selected;
      var paymentOptions = this.props.paymentOptions;
      return _react["default"].createElement(_browser.Container, null, _react["default"].createElement(_browser.Title, null, _react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "htmPayment.amount.selector.title"
      })), _react["default"].createElement("form", {
        onSubmit: function onSubmit(e) {
          return _this2.handleSubmit(e);
        }
      }, _react["default"].createElement(OptionsContainer, null, _react.Children.toArray(paymentOptions.map(function (option) {
        return _react["default"].createElement(_AmountSelection2.Option, {
          checked: selected === option.name,
          onClick: function onClick() {
            return _this2.handleSelect(option);
          }
        }, _react["default"].createElement(_AmountSelection2.RadioButton, {
          value: option.name,
          checked: selected === option.name
        }), _react["default"].createElement(_AmountSelection2.Label, {
          text: option.label,
          subText: option.subLabel,
          date: option.date
        }, option.isInput ? _react["default"].createElement(_AmountSelection2.AmountInput, {
          defaultValue: option.defaultValue,
          onChange: function onChange(event) {
            return _this2.handleInputSelectAmount(event);
          },
          required: selected === option.name
        }) : _react["default"].createElement(_AmountSelection2.Amount, {
          value: option.amount
        })));
      }))), _react["default"].createElement(_browser.Button, {
        type: "submit",
        color: "green",
        size: "large"
      }, _react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "htmPayment.button.next"
      }))));
    }
  }]);
}(_react.PureComponent);
var PaymentSelectionWithContext = function PaymentSelectionWithContext(props) {
  var _context$actions;
  var context = (0, _react.useContext)(_PaymentContext["default"]);
  return _react["default"].createElement(AmountSelection, (0, _extends2["default"])({
    setAmount: context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions.setAmount,
    paymentOptions: context === null || context === void 0 ? void 0 : context.paymentOptions
  }, props));
};
var _default = exports["default"] = PaymentSelectionWithContext;